module.exports = __webpack_public_path__ + "img/wx.308ea77c.jpg";